export default __webpack_public_path__ + "static/media/home1_bg.d979ef38.png";